import React from "react";
import headshot from "../../assets/headshot.png";
import "./Home.css";

function Home() {
  const skills = [
    "TypeScript",
    "JavaScript",
    "Python",
    "C++ / C",
    "React / React Native",
    "Angular / RxJS",
    "Redux",
    "Tailwind CSS",
    "Bootstrap",
    "Zod",
    "HTML / CSS",
    "SQL",
    "MongoDB",
    "Git",
    "JIRA",
    "npm",
    "REST / RPC APIs",
    "OOP",
    "Photoshop",
    "Claude Code Subagents",
    "Claude Skills",
    "English",
    "Spanish",
  ];

  const projects = [
    { name: "SnapCart", tag: "TypeScript, Next.js, Postgres, Claude vision, Vercel", to: "/snapcart" },
    { name: "Popdle", tag: "Python, React, Claude, Render", to: "/popdle" },
    { name: "Spotify Me", tag: "React Native, Spotify Web API", to: "/spotify-me" },
    { name: "Book It", tag: "React, Ruby on Rails, PostgreSQL, Redux", to: "/book-it" },
    { name: "My Booknook", tag: "React, Ruby on Rails, PostgreSQL, Cloudinary", to: "/my-booknook" },
    { name: "HarvardX CS50x", tag: "C", to: "/harvardX" },
    { name: "Episode Interactive", tag: "Donacode", to: "/episode" },
  ];

  return (
    <div className="vintage-page">
      <h1 className="vintage-title">
        portfolio <span className="vintage-year">2026</span>
      </h1>
      <div className="vintage-byline">amber lynn</div>

      <div className="vintage-grid">
        <div className="vintage-section vintage-photo-col">
          <img src={headshot} alt="Amber Lynn" className="vintage-photo" />
          <div>
            <h2>about me</h2>
            <p>Hello, I'm Amber 🙂</p>
            <p>
              I'm a versatile, full-stack software engineer with a background
              in game design and graphic design — currently the frontend lead
              for the Growth team and Frontend Guild at{" "}
              <a className="vintage-link" href="https://www.dronedeploy.com/" target="_blank" rel="noopener noreferrer">
                DroneDeploy
              </a>
              . I love solving problems, creative environments, and getting
              lost in my work.
            </p>
            <p>
              When I'm not coding, I'm reading, writing poetry, baking,
              knitting, collecting vinyl records, arranging flowers, or
              wandering through a park.
            </p>
          </div>
        </div>

        <div className="vintage-section">
          <div>
            <h2>experience</h2>
            <p className="vintage-exp-role">DroneDeploy</p>
            <p className="vintage-exp-dates">sept. 2023 // present</p>
            <p className="vintage-exp-progression">Intern → SWE 4 → SWE 5 → SWE 6 / Frontend Lead</p>
            <ul className="vintage-exp-bullets">
              <li>Serve as Frontend Lead for the Growth Team and engineering-wide Frontend Guild, leading technical talks and aligning teams on frontend patterns across the org.</li>
              <li>Built a Product Qualified Lead (PQL) system with a new RPC endpoint that uses Pub/Sub to process data through our Image Indexer to identify construction events and fire qualified leads into Salesforce, directly supporting the sales pipeline.</li>
              <li>Discovered and implemented a method to pull project data from the Procore API to auto-populate ACV contract values, eliminating 90+ minutes of manual data entry per project and supporting accounts tied to $13.9M ARR.</li>
              <li>Led full-stack technical design of upsell/cross-sell flows, ACV data management dashboard, a persistent overage banner nudging customers toward plan upgrades, bulk upload projects, and more.</li>
              <li>Optimized web app performance by removing client-side polling on the user settings page, reducing project-settings API calls by ~97% per project (61 → ~2 calls/day), saving an estimated 59,000+ requests/day across affected projects.</li>
              <li>Migrated internal customer and account management tooling across repositories for stronger AE usage.</li>
              <li>Refactored unreadable legacy frontend component into a reusable, streamlined internal design component.</li>
              <li>Built Claude AI skills and agents for PR reviewing, learning industry standards, using up-to-date patterns, and accelerating large-scale projects.</li>
              <li>Resolved critical customer escalations around subscription billing, security gaps, and map-related bugs while maintaining high test coverage.</li>
            </ul>

            <p className="vintage-exp-role" style={{ marginTop: 10 }}>Pocket Gems — Episode Interactive</p>
            <p className="vintage-exp-dates">sept. 2019 // sept. 2023</p>
            <p className="vintage-exp-progression">Visual Storytelling Scripter → Associate Story Layout Artist → Lead Coder</p>
            <ul className="vintage-exp-bullets">
              <li>Designed and implemented a customer-facing feature that improved monetization in-game by 25%.</li>
              <li>Increased revenue by 2% by developing a new onboarding experience with a product manager.</li>
              <li>Ideated and led 8 initiatives that increased monetization and cut development time by ~323 hours.</li>
              <li>Developed visuals, interactivity, and decision tree architecture for in-game stories, monetizing at $0.08+/chapter.</li>
            </ul>
          </div>
        </div>

        <div className="vintage-section vintage-section-fixed-gap">
          <div>
            <h2>education</h2>
            <p>
              <span className="vintage-tag">degree</span>
              <br />
              B.A. in Liberal Studies, Law/Business/Society Track — Florida
              International University
            </p>
            <p>
              <span className="vintage-tag">certificate</span>
              <br />
              Software Engineering — Flatiron School
            </p>
          </div>

          <div className="vintage-skills-block">
            <h2>skills</h2>
            <div className="vintage-skill-tags">
              {skills.map((s) => (
                <span className="vintage-tag" key={s}>{s}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="vintage-section vintage-projects">
        <h2>projects</h2>
        <ul>
          {projects.map((p) => (
            <li key={p.name}>
              {p.to ? (
                <a className="vintage-link" href={p.to}>{p.name}</a>
              ) : (
                <span className="vintage-link-static">{p.name}</span>
              )}
              <span className="vintage-project-tag">{p.tag}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Home;
